import { render, staticRenderFns } from "./RegisterPickupLocation.vue?vue&type=template&id=44c96280"
import script from "./RegisterPickupLocation.vue?vue&type=script&lang=js"
export * from "./RegisterPickupLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports